import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-base-datepicker',
  standalone: true,
  imports: [
    MatFormFieldModule,
    MatDatepickerModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule
],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <div class="flex justify-center items-center space-x-1">
      <ng-content></ng-content>
    </div>
  `
})
export class BaseDatepickerComponent {
  @Input() date: Date = new Date();
  @Output() dateChange = new EventEmitter<Date>();
}
